import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import NavPrimary from './NavPrimary';
import User from '../../containers/User';
import AddContact from '../Modals/AddContact';
import { HeaderModal } from '../../contexts';
import { Typeahead } from 'react-bootstrap-typeahead';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import PaidIcon from '@mui/icons-material/Paid';
import CommsAlert from './CommsAlert';
import Chip from '@mui/material/Chip';
import { NylasProvider } from '@nylas/nylas-react';

import { Grid, TextField, Avatar, IconButton } from '@mui/material';
import { Search, Notifications, AccountCircle } from '@mui/icons-material';


import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import 'react-bootstrap-typeahead/css/Typeahead.css';


const AccountBanner = ( { label } ) => {
    return (
        <AppBar position="static" color="error">
            <Toolbar style={ { minHeight: '24px' } }>
                <Typography>Currently Viewing: {label}</Typography>
            </Toolbar>
        </AppBar>
    );
}


const Header = React.memo( ( { user, aid, uid, viewing, contacts, loans } ) => {
    const nav = useNavigate();
    const globalAdd = 'https://tf-crm-images.s3.amazonaws.com/System/TF_CRM_GlobalAdd.png';
    const [ modal, setModal ] = useState();
    const [ show, setShow ] = useState(false);
    const [ searchList, setSearchList ] = useState( [] );
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ showCurrAccount, setShowCurrAccount ] = useState( false );
    const [ currAccountLabel, setCurrAccountLabel ] = useState( '' );
    const [ acctChips, setAcctChips ] = useState( {} );
    const [ showChip, setShowChip ] = useState( false );
    const [ viewingMultipleAccounts, setViewingMultipleAccounts ] = useState( false );


    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'contact':
                setModal( <AddContact close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const switchSearch = ( obj ) => {
        if ( obj && obj.length ) {
            if ( obj[0].type === 'contact' ) {
                nav( `/contact/${obj[0].cid}` );
            } else {
                nav( `/loan/${obj[0].id}` );
            }
        }
    };

    const filter = ( opt, props ) => {
        const q = props.text.toLowerCase();

        // no query - show everything
        if ( !q || !q.length ) {
            return true;
        }

        // check default label key - generally the contact name
        if ( props.labelKey( opt ).toLowerCase().includes( q ) ) {
            // const c = contacts[opt.cid];
            // c['match'] = '';
            return true;
        }

        if ( opt.type === 'contact' ) {
            // check for partner/cobo name
            if ( opt.firstnamePartner1?.length && opt.lastnamePartner1?.length && `${opt.firstnamePartner1} ${opt.lastnamePartner1}`.toLowerCase().includes( q ) ) {
                const c = contacts[opt.cid];
                c['match'] = `Partner: ${opt.firstnamePartner1} ${opt.lastnamePartner1}`;
                return true;
            }

            // loop individual fields
            const fields = Object.keys( opt );
            const ignore = [
                'id',
                'aid',
                'type', 
                'match', 
                'cid', 
                'firstname', 
                'lastname', 
                'namePreferred',
                'firstnamePartner1', 
                'lastnamePartner1', 
                'phone', 
                'phoneMobile', 
                'phoneWork', 
                'phonePartner1', 
                'phonePartner2',
                'team',
                'priRole',
                'loId'
            ]
            for ( let i = 0; i < fields.length; i++ ) {
                const k = fields[i];

                if ( !ignore.includes( k ) && opt[k] && opt[k].length ) {
                    if ( opt[k].toLowerCase().includes( q ) ) {
                        const c = contacts[opt.cid];
                        try {
                            c['match'] = `${k}: ${opt[k]}`;
                        } catch ( e ) {
                            console.log( 'error setting match: ', e, opt.cid  );
                        }
                        return true;
                    }
                } else if ( /\d/.test( q ) && !/[a-zA-Z]/.test( q ) && [ 'phone', 'phoneMobile', 'phoneWork', 'phonePartner1', 'phonePartner2' ].includes( k ) && opt[k] && opt[k].length ) {
                    if ( opt[k].includes( cleanPhone( q ) ) ) {
                        const c = contacts[opt.cid];
                        c['match'] = `${k}: ${opt[k]}`;
                        return true;
                    }
                }
            }
        } else {
            if ( opt.subjectAddress?.length && opt.subjectAddress.toLowerCase().includes( q ) ) {
                return true;
            }
            if ( opt.fileNum?.length && opt.fileNum.toLowerCase().includes( q ) ) {
                return true;
            }
        }
        
        // c['match'] = '';
        return false;
    }

    const displayMatch = ( opt, props ) => {
        const formatName = ( c ) => {
            let n = c.firstname + ' ';
            if ( c.namePreferred && c.namePreferred.length ) {
                n += `(${c.namePreferred}) `;
            }
            n += c.lastname;
            return n;
        }

        return (
            ( opt.type === 'contact' ) ? (
                <Row>
                    <Col>
                        <Row className='align-items-center'>
                            <Col xs='auto' className='pe-1'>
                                {
                                    ( opt.priRole === 'borrower' ) ? (
                                        <PersonIcon />
                                    ) : ( opt.priRole === 'partner' ) ? (
                                        <BusinessIcon />
                                    ) : (
                                        <BadgeIcon />
                                    )
                                }
                            </Col>
                            <Col className='ps-1'>
                                {formatName( opt )}
                            </Col>
                            {
                                ( showChip && aid !== opt.aid ) ? (
                                    <Col xs='auto' className='pe-1'><Chip label={acctChips[opt.aid]} variant='outlined' size='small' /></Col>
                                ) : (
                                    null
                                )
                            }
                        </Row>
                        {
                            ( opt.match?.length ) ? (
                                <Row>
                                    <Col><small>~ {opt.match}</small></Col>
                                </Row>
                            ) : (
                                null
                            )
                        }
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col>
                        <Row className='align-items-center'>
                            <Col xs='auto' className='pe-1'>
                                <PaidIcon />
                            </Col>
                            <Col className='ps-1'>
                                {opt.subjectAddress}        
                            </Col>
                            {
                                ( showChip ) ? (
                                    <Col xs='auto' className='pe-1'><Chip label={acctChips[opt.aid]} variant='outlined' size='small' /></Col>
                                ) : (
                                    null
                                )
                            }
                        </Row>
                        <Row>
                            <Col><small>~ {opt.name}</small></Col>
                        </Row>
                    </Col>
                </Row>
            )
        )
    }

    const cleanPhone = ( p ) => {
        if ( p && p.length ) {
            return p.replace( /\D/g, '' );
        }
        return p;
    }

    useEffect( () => {
        let list = [];
        if ( contacts ) {
            const sharePartners = ( user && user.org && user.org.sharePartners === true ) ? true : false;

            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];

                if ( ( c.priRole === 'partner' && sharePartners ) || viewing.includes( c.aid ) ) {
                    list.push( {
                        id: c.cid,
                        aid: c.aid,
                        type: 'contact',
                        cid: c.cid,
                        firstname: c.firstname,
                        lastname: c.lastname,
                        name: c.name,
                        fullnamePreferred: `${c.namePreferred} ${c.lastname}`,
                        namePreferred: c.namePreferred,
                        email: c.email,
                        email2: c.email2,
                        phone: cleanPhone( c.phone ),
                        phoneMobile: cleanPhone( c.phoneMobile ),
                        phoneWork: cleanPhone( c.phoneWork ),
                        namePartner1: c.namePartner1,
                        firstnamePartner1: c.firstnamePartner1,
                        lastnamePartner1: c.lastnamePartner1,
                        emailPartner1: c.emailPartner1,
                        phonePartner1: cleanPhone( c.phonePartner1 ),
                        firstnamePartner2: c.firstnamePartner2,
                        lastnamePartner2: c.lastnamePartner2,
                        emailPartner2: c.emailPartner2,
                        phonePartner2: cleanPhone( c.phonePartner2 ),
                        team: c.team,
                        employer: c.employer,
                        priRole: c.priRole,
                        loId: c.loId
                    } );
                }
            } );
        }

        if ( loans ) {
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];

                if ( viewing.includes( l.aid ) ) {
                    list.push( {
                        id: l.lid,
                        aid: l.aid,
                        type: 'loan',
                        lid: l.lid,
                        subjectAddress: l.subjectAddress,
                        name: l.name,
                        fileNum: l.fileNum
                    } );
                }
            } );
        }

        list.sort( ( a, b ) => {
            if ( a.type === 'contact' ) {
                if ( b.type === 'loan' ) {
                    return -1;
                }
                if ( !a.name && !b.name ) {
                    return 0;
                }
                if ( !a.name ) {
                    return 1;
                }
                if ( !b.name ) {
                    return -1;
                }
                if ( a.name.toLowerCase() < b.name.toLowerCase() ) {
                    return -1;
                }
                if ( a.name.toLowerCase() > b.name.toLowerCase() ) {
                    return 1;
                }
                return 0;
            }
            if ( b.type === 'contact' ) {
                return 1;
            }
            if ( a.subjectAddress ) {
                if ( !b.subjectAddress ) {
                    return -1;
                }
                if ( a.subjectAddress.toLowerCase() < b.subjectAddress.toLowerCase() ) {
                    return -1;
                }
                if ( a.subjectAddress.toLowerCase() > b.subjectAddress.toLowerCase() ) {
                    return 1;
                }
                return 0;
            }
            if ( b.subjectAddress ) {
                return 1;
            }
            return 0;
        } );

        setSearchList( list );
    }, [ contacts, loans, aid, uid, viewing, user ] );

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length ) {
            const list = {};
            user.additionalAccounts.forEach( f => list[f.aid] = f.label );

            const label = ( viewing && viewing.length ) ? viewing.join( ', ' ) : '';
            
            setShowChip( viewing.length > 1 );
            setAcctChips( list );
            setCurrAccountLabel( label );
            setShowCurrAccount( true );
        } else {
            setCurrAccountLabel( '' );
            setShowCurrAccount( false );
        }

        setViewingMultipleAccounts( viewing.length > 1 );
    }, [ user.additionalAccounts, viewing ] );

    return (
        // <Navbar fixed="top">
            <Container fluid className="tf-header-container">
                <HeaderModal.Provider value={ { openModal, closeModal, setModal } }>
                    <Row className='align-items-center'>
                        {
                            showCurrAccount ? (
                                <AccountBanner label={currAccountLabel} />
                            ) : (
                                null
                            )
                        }
                        <Grid container alignItems="center" spacing={3} style={{ width: '100%', padding: '10px' }}>
                            <Grid item xs={4} sm={3} md={3}>
                                <img src="/images/ThirdFloorLogo.png" height="40" alt="Third Floor" />
                            </Grid>

                            <Grid item xs={4} sm={6} md={6} container justifyContent="center">
                                <Typeahead
                                    filterBy={ filter }
                                    id="tf-global-search"
                                    labelKey={ ( option ) => ( option.type === 'contact' ) ? `${option.firstname} ${option.lastname}` : `${option.subjectAddress}` }
                                    onChange={ switchSearch }
                                    options={ searchList }
                                    placeholder="Search Contacts/Loans..."
                                    renderMenuItemChildren={ displayMatch }
                                    style={ { width: '300px' } }
                                />
                            </Grid>

                            <Grid item xs={4} sm={3} md={3} container justifyContent="flex-end" alignItems="center" >
                                <Grid style={{ paddingRight: '10px' }}><CommsAlert /></Grid>
                                <Grid style={{ paddingRight: '14px' }}><Dropdown className='tf-global-add'>
                                    <Dropdown.Toggle variant='link' className='p-0'>
                                        <img src={globalAdd} height="25" style={ { borderRadius: '15%' } } alt='' />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={ () => handleModal( 'contact' ) } disabled={viewingMultipleAccounts}>Create Contact</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown></Grid>
                                <Grid>
                                    {/* <NylasProvider serverBaseUrl="http://localhost:3000"> */}
                                        <User />
                                    {/* </NylasProvider> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Row>
                    <Row>
                        <NavPrimary />
                    </Row>
                </HeaderModal.Provider>
                <Modal show={show} onHide={closeModal} centered size='lg'>
                    {modal}
                </Modal>
            </Container>
        // </Navbar>
    )
} );

const mapProps = ( state ) =>( {
    user: state.user,
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    loggedIn: state.user.password,
    sid: state.user.sid,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Header );